import http from '@/common/http';




export const adminUpdateById = async (params) => {

   return await http.post('/web/admin/updateById', {data: params});
}



// 文件上传
export const adminUpload = async (params) => {

   return await http.post('/web/admin/upload', {data: params});
}


// 实名认证个人
export const adminUserCertification = async (params) => {

   return await http.post('/web/admin/userCertification', {data: params});
}


// 实名认证企业
export const insertUserRealnameDOData = async (params) => {

   return await http.post('/web/htgl/insertUserRealnameDOData', {data: params});
}




// 用户邀请信息
export const selectMyInfo = async (params) => {

   return await http.get('/web/admin/selectMyInfo', {data: params});
}

// 用户邀请信息
export const getByUserId = async (params) => {

   return await http.post('/web/app/getByUserId', {data: params});
}





// 用户申请
export const saveOrUpdateTbOrder = async (params) => {

   return await http.post('/web/app/saveOrUpdateTbOrder', {data: params});
}
// 获取用户信息
export const getByAdmin = async (params) => {

   return await http.post('/web/app/getByAdmin', {data: params});
}

// 分佣
export const getByOrderOk = async (params) => {

   return await http.post('/web/app/getByOrderOk', {data: params});
}

// 商品类型
export const getByPrice = async (params) => {

   return await http.post('/web/app/getByPrice', {data: params});
}


// 用户申请列表
export const appGetList = async (params) => {

   return await http.post('/web/app/getList', {data: params});
}


// 用户申请列表
export const getTbOrderById = async (params) => {

   return await http.post('/web/app/getTbOrderById', {data: params});
}



// 删除订单
export const deleteTbOrderById = async (id) => {

   return await http.get('/web/app/deleteTbOrderById/' + id);
}





// 任务列表
export const orderPageList = async (params) => {

   return await http.post('/web/orders/orderPageList', {data: params});
}


// 获取openid
export const getByOpenId = async (params) => {

   return await http.post('/web/wxpay/getByOpenId', {data: params});
}


// 付款
export const wxpayOrder = async (params) => {

   return await http.post('/web/wxpay/wxCreateOrder', {data: params});
}

// openid获取用户信息
export const openIdLogin = async (params) => {

   return await http.post('/adminLogin/openIdLogin', {data: params});
}

// 获取钱包详情
export const getLqDatile = async (params) => {

   return await http.post('/web/app/getLqDatile', {data: params});
}

// 存证文件列表
export const storageEvidenceGetFileList = async (params) => {

   return await http.post('/web/storageEvidence/getFileList', {data: params});
}

// 存证文件删除
export const storageEvidencedDeleteFileList = async (params) => {

   return await http.post('/web/storageEvidence/deleteFileList', {data: params});
}

// 查看保管单
export const storageEvidenceGetCustodyNote = async (params) => {

   return await http.get('/web/storageEvidence/getCustodyNote', {data: params});
}

// 提现
export const insertDataDeposit = async (params) => {

   return await http.post('/web/app/insertDataDeposit', {data: params});
}

// 提现记录
export const getDepositDOPageList = async (params) => {

   return await http.post('web/htgl/getDepositDOPageList', {data: params});
}

// 固证证书下载
export const downloadGZZS = async (params) => {

   return await http.post('/web/storageEvidence/downloadGZZS', {data: params});
}

// 工作站列表
export const selectGzzList = async (params) => {

   return await http.get('/web/admin/selectGzzList', {data: params});
}

// 同步固证用户信息
export const evidenceUserInit = async (params) => {

   return await http.post('/web/storageEvidence/evidenceUserInit', {data: params});
}

// 创建公证订单
export const evidenceSelectData = async (params) => {

   return await http.post('/notarization/evidenceSelectData', {data: params});
}

// 查询公证详情
export const evidenceDetail = async (params) => {

   return await http.get('/notarization/evidenceDetail', {data: params});
}

// 查询公证保全号集合
export const getSelectBaoquan = async (params) => {

   return await http.get('/notarization/evidenceGetSelectBaoquan', {data: params});
}

// 提交告知书
export const writeTell = async (params) => {

   return await http.post('/notarization/evidenceWriteTell', {data: params});
}
// 提交申请书
export const evidenceWriteApply = async (params) => {

   return await http.post('/notarization/evidenceWriteApply', {data: params});
}

// 受理通知书
export const evidenceWriteAdvice = async (params) => {

   return await http.post('/notarization/evidenceWriteAdvice', {data: params});
}
// 问询笔录
export const evidenceWriteNote = async (params) => {

   return await http.post('/notarization/evidenceWriteNote', {data: params});
}

// 签署验证码
export const evidenceSendCode = async (params) => {

   return await http.post('/notarization/evidenceSendCode', {data: params});
}

// 提交签署
export const evidenceSign = async (params) => {

   return await http.post('/notarization/evidenceSign', {data: params});
}
